<template>
    <div class="modal fade"
        ref="download-modal"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        tabindex="-1">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ _.get(asset, 'name') }}</h4>
                </div>
                <div class="modal-body">
                    <form v-if="asset" ref="download-form">
                        <!-- <img :src="_.imgPath(asset, 'Cover') + '?asset_token=' + asset_token" class="w-100" style="max-height: "> -->

                        <div v-if="!_.isEmpty(errors)" class="alert alert-danger">
                            <p>
                                <strong>Sorry, there was an error submitting your form.</strong>
                                <br>Please complete the following fields:
                            </p>
                            <ul>
                                <li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
                            </ul>
                        </div>
                        <div v-else-if="message" class="" v-html="message"></div>
                        <p v-else class="">
                            Please enter your details below to download the requested file. All fields are required.
                        </p>
                        <div v-if="!submitted">
                            <input v-model="asset.id" name="file" type="hidden">
                            <div class="form-group">
                                <label :for="'form-firstname-' + randomKey">First name</label>
                                <input v-model="formData.firstname"
                                    :id="'form-firstname-' + randomKey"
                                    name="firstname"
                                    type="text"
                                    class="form-control">
                            </div>
                            <div class="form-group">
                                <label :for="'form-lastname-' + randomKey">Last name</label>
                                <input v-model="formData.lastname"
                                    :id="'form-lastname-' + randomKey"
                                    name="lastname"
                                    type="text"
                                    class="form-control">
                            </div>
                            <div class="form-group">
                                <label :for="'form-email-' + randomKey">Email</label>
                                <input v-model="formData.email"
                                    :id="'form-email-' + randomKey"
                                    name="email"
                                    type="text"
                                    class="form-control">
                            </div>
                            <div class="form-group">
                                <label :for="'form-description-' + randomKey">What Best Describes You?</label>
                                <select v-model="formData.description"
                                    :id="'form-description-' + randomKey"
                                    name="description"
                                    type="text"
                                    class="form-control">
                                    <option v-for="value in descriptions"
                                        :value="value"
                                        >{{ value }}</option>
                                </select>
                            </div>
                            <div class="centered text-center"></div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer text-center">
                    <!-- <button v-if="downloadLink" -->
                    <!--     v-on:click="downloadFile" -->
                    <!--     type="button" -->
                    <!--     class="btn btn-cart btn-primary" -->
                    <!--     >Download</button> -->
                    <button v-if="loading"
                        type="button"
                        class="btn btn-cart btn-primary"
                        disabled
                        >Please wait</button>
                    <button v-else-if="!submitted"
                        :id="'grecaptcha-' + randomKey"
                        type="button"
                        class="btn btn-cart btn-primary"
                        >Download</button>
                    <button v-on:click="closeModal"
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal" tabindex="-1"
                        >Close</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import jsonp from 'jsonp';
import UtilsMixin from './UtilsMixin';

export default {
    data() {
        let download = null;

        try {
            download = JSON.parse(window.localStorage.getItem('_download'));
            download = (download.expired_at > Date.now()) ? download : null;
        } catch (e) {
            // ignore
        }

        return {
            download,
            randomKey: _.parseInt(Math.random() * 1000000),
            loading: false,
            submitted: false,
            // showModal: false,
            message: null,
            errors: [],
            recaptchaInit: false,
            formData: {
                firstname: _.get(download, 'attributes.firstname', null),
                lastname: _.get(download, 'attributes.lastname', null),
                email: _.get(download, 'attributes.email', null),
                description: _.get(download, 'attributes.description', null),
                'g-recaptcha-response': null,
            }
        }
    },

    props: [
        'asset',
        'show',
        'config',
    ],

    mixins: [UtilsMixin],

    mounted() {
        this.$modal.on('hide.bs.modal', () => {
            this.showModal = false;
            return this.$emit('hide');
        })

        this.$modal.on('shown.bs.modal', () => {
            this.renderRecaptcha();
        })
    },

    watch: {
        showModal(newVal) {
            if (newVal) {
                this.$modal.modal('show');
                this.submitted = false;
                this.message = '';
            }
        },
    },

    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(newVal) {
                if ( newVal) {
                    return this.$emit('hide');
                } else {
                    return this.$emit('show');
                }
            },
        },

        // asset() {
            // return _.get(this.initialData, 'asset');
        // },

        asset_token() {
            return _.get(this.config, 'asset_token');
        },

        $modal() {
            return $(this.$refs['download-modal']);
        },

        $form() {
            return $(this.$refs['download-form']);
        },

        recaptchaKey() {
            return _.get(this.config, 'recaptcha_site_key');
        },

        formConfig() {
            return _.get(this.config, 'form', {});
        },

        downloadLink() {
            if (this.asset && this.download) {
                let token = _.get(this.download, 'attributes.token', null)
                return token ? _.filePath(this.asset, true, { asset_token: token }) : _.filePath(this.asset, true);
            }

            return null;
        },

        descriptions() {
            return [
                "Shed Builder",
                "Residential Builder",
                "Merchant/Distributor",
                "Contractor/Commercial Builder",
                "Garage Door Company",
                "Truck Body Company",
                "Custom/One Off",
                "Architect/Specifier/Engineer",               
            ]
        }
    },

    methods: {
        closeModal() {
            this.showModal = false;
        },

        openModal() {
            this.showModal = true;
        },

        downloadFile() {
            let link = window.location.origin + this.downloadLink;
            window.open(link, '_blank');
        },

        submit() {
            let data = this.getFormData();
            this.loading = true;

            return this.api.postData('/downloads', {}, data)
                .then(res => {

                    // set expiry time to 12 hours
                    _.set(res, 'expired_at', Date.now() + 43200000);
                    window.localStorage.setItem('_download', JSON.stringify(res));
                    this.download = res;
                    this.errors = [];
                    this.submitted = true;
                    this.message = `Your file will be automatically downloaded. ` +
                        `If your file does not start downloading automatically please click ` +
                        `<a href="{{downloadLink}}" target="_blank">here</a> to download your file`
                        .replace('{{downloadLink}}', this.downloadLink);

                    let ssData = {
                        firstname: _.get(res, 'attributes.firstname', null),
                        lastname: _.get(res, 'attributes.lastname', null),
                        email: _.get(res, 'attributes.email', null),
                        description: _.get(res, 'attributes.description', null),
                        file: _.get(res, 'attributes.file.name', null),
                    }
                    this.sharpspringPush(ssData, _.get(this.config, 'sharpspring_url'), _.get(this.config, 'sharpspring_endpoint'));

                    setTimeout(() => {
                        window.open(this.downloadLink);
                    }, 3000)
                })
                .catch(e => {
                    let errors = _.get(e, 'response.data.message', null);
                    this.errors = errors ? _.split(errors, ',') : [];
                    this.message = null;
                })
                .finally(() => {
                    this.loading = false;
                    this.renderRecaptcha();
                })
        },

        getFormData() {
            let params = new URLSearchParams(this.$form.serialize());
            let result = {};

            params.forEach((val, key) => {
                result[key] = val;
            })

            return _.assign({}, this.formData, result);
        },

        renderRecaptcha() {
            // if (this.download) {
            //     return;
            // }

            // if (this.recaptchaInit) {
            //     try {
            //         grecaptcha.reset(0);
            //         grecaptcha.reset(1);
            //         grecaptcha.reset(2);
            //     } catch (e) {
            //         // ignore
            //     }
            // }

             // if (!this.recaptchaInit) {
                this.recaptchaInit = true;
                let button = `grecaptcha-${this.randomKey}`;
                grecaptcha.render(button, {
                    sitekey: this.recaptchaKey,
                    callback: this.updateRecaptcha,
                })
            // }
        },

        updateRecaptcha(token) {
            this.formData['g-recaptcha-response'] = token;
            this.submit();
        },

        sharpspringPush(data, url, endpoint) {
            var __ss_noform = window.__ss_noform || [];
            // __ss_noform.push(['baseURI', url]);
            // __ss_noform.push(['endpoint', endpoint]);
            let ssTracking = this.getCookie('__ss_tk');
            let params = new URLSearchParams(_.assign({}, data, { trackingid__sb: ssTracking }));

            return jsonp(`${url}${endpoint}/jsonp/?${params.toString()}`, null, (err, data) => {
                console.log(err, data)
            })
        },

        getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/DownloadModalComponent.vue